import React from 'react';
export function HeroSection() {
  return <section aria-label="Presentazione di Fisica Pronta" className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-127">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-128">
        <div className="flex flex-col items-center w-full pt-[15px] pb-[15px]" data-id="element-129">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-130">
            <span className="text-xl" aria-hidden="true" data-id="element-131">
              🔬
            </span>{' '}
            FISICA PRONTA
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[0.95] pt-[10px] pb-[10px]" data-id="element-132">
            Tutto il tuo anno di
            <br data-id="element-133" />
            <span className="text-brand-accent" data-id="element-134">Fisica risolto.</span>
          </h1>
        </div>

        <div className="w-full max-w-[280px] sm:max-w-sm md:max-w-xl mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" data-id="element-135">
          <img src="https://cdn.magicpatterns.com/uploads/qfdVyY6dXY4hpCHmgAkWnc/Diseno-sin-titulo-_70_.webp" alt="Fisica Pronta — 6 volumi completi per docenti di scuola secondaria" className="w-full h-auto object-contain relative z-10 mt-[-5px] mb-[-10px]" loading="eager" fetchPriority="high" width={385} height={385} data-id="element-136" />
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-137">
          <p className="text-base sm:text-lg md:text-2xl text-white/85 leading-relaxed px-2 mb-6 md:mb-10 max-w-2xl" data-id="element-138">
            6 volumi pronti all'uso con lezioni, esperimenti e verifiche
            editabili. Pianifica l'intero anno in un pomeriggio e{' '}
            <span className="text-brand-accent font-bold" data-id="element-139">
              riprenditi le tue domeniche.
            </span>
          </p>

          <div className="flex flex-nowrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10 w-full mx-auto px-1" data-id="element-140">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-141">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-142">
              ⚡ Accesso immediato
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-143">
              🇮🇹 Curriculum Italiano
            </span>
          </div>

          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black text-xl md:text-3xl py-5 md:py-6 px-10 md:px-14 rounded-2xl transition-colors flex items-center justify-center mb-5 md:mb-8 mx-4 sm:mx-0 ml-[50px] mr-[50px] pl-[0px] pr-[0px]" data-id="element-144">
            → VOGLIO FISICA PRONTA ORA
          </button>

          <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-5 gap-y-2 text-xs md:text-sm text-white/80 font-semibold" data-id="element-145">
            <span className="flex items-center gap-1.5" data-id="element-146">
              <span className="text-brand-accent" data-id="element-147">🛡️</span> Soddisfatti o
              rimborsati in 7 giorni
            </span>
            <span className="text-white/20" aria-hidden="true" data-id="element-148">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-149">
              <span className="text-brand-accent" data-id="element-150">🔒</span> Pagamento sicuro
            </span>
            <span className="text-white/20" aria-hidden="true" data-id="element-151">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-152">
              <span className="text-brand-accent" data-id="element-153">💳</span> Pagamento unico
            </span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-154">
          <div className="text-center" data-id="element-155">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-156">
              +1.500
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-157">
              docenti si fidano
            </div>
          </div>
          <div className="text-center" data-id="element-158">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-159">
              6
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-160">
              Volumi pronti
            </div>
          </div>
          <div className="text-center" data-id="element-161">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-162">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-163">
              Valutazione
            </div>
          </div>
          <div className="text-center" data-id="element-164">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-165">
              🇮🇹
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-166">
              In tutta Italia
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-167">
          {[{
          initials: 'MG',
          name: 'Marcela G.',
          loc: 'Roma | Docente di Fisica',
          quote: "Finalmente un materiale che parla la lingua della nostra scuola. Ho organizzato la programmazione annuale in un paio d'ore."
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Milano | Docente di Fisica',
          quote: 'Le mie lezioni hanno finalmente una struttura solida.'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Napoli | Docente di Fisica',
          quote: 'Non sono più arrivato in classe impreparato.'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-168">
              <div className="flex items-center gap-3 mb-3" data-id="element-169">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-170">
                  {test.initials}
                </div>
                <span className="text-brand-accent text-sm" aria-label="5 estrellas" data-id="element-171">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-172">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/70 uppercase tracking-wider font-bold" data-id="element-173">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}